"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listShop = listShop;
exports.createShop = createShop;
exports.readShop = readShop;
exports.updateShop = updateShop;
exports.deleteShop = deleteShop;

var _request = _interopRequireDefault(require("@/utils/request"));

function listShop(query) {
  return (0, _request.default)({
    url: '/shopEmail/list',
    method: 'get',
    params: query
  });
}

function createShop(data) {
  return (0, _request.default)({
    url: '/shopEmail/create',
    method: 'post',
    data: data
  });
}

function readShop(data) {
  return (0, _request.default)({
    url: '/shopEmail/read',
    method: 'get',
    data: data
  });
}

function updateShop(data) {
  return (0, _request.default)({
    url: '/shopEmail/update',
    method: 'post',
    data: data
  });
}

function deleteShop(data) {
  return (0, _request.default)({
    url: '/shop/delete',
    method: 'post',
    data: data
  });
}